import React from 'react';
import './sectitle.css';

const SecTitle = (props) => {
    return ( <>
    <div className="secTitle">
        <h2>{props.secTitle}</h2>
        <h3>{props.secDesc}</h3>
    </div>
    </> );
}
 
export default SecTitle;